class NotxsSocialFeed extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-notxs-feed-viewport]');
    this.cards = Array.from(this.querySelectorAll('[data-notxs-feed-card]'));
    this.bindDialogs();
    this.bindForms();
    this.startMobileAutoplay();
  }

  bindDialogs() {
    this.cards.forEach((card) => {
      const dialog = card.querySelector('[data-notxs-dialog]');
      const openers = card.querySelectorAll('[data-notxs-open-card]');
      const close = card.querySelector('[data-notxs-close]');

      openers.forEach((opener) => {
        opener.addEventListener('click', () => {
          if (card.dataset.notxsPopupEnabled !== 'true' || !dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        });
      });

      if (close && dialog) {
        close.addEventListener('click', () => dialog.close());
      }

      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }
    });
  }

  bindForms() {
    this.querySelectorAll('[data-notxs-product-form]').forEach((form) => {
      bindNotxsProductForm(form);
    });
  }

  disconnectedCallback() {
    if (this._autoplayInterval) {
      clearInterval(this._autoplayInterval);
      this._autoplayInterval = null;
    }
  }

  startMobileAutoplay() {
    if (!this.viewport || this.dataset.mobileAutoplay !== 'true') return;

    const speed = Number(this.dataset.autoplaySpeed || 4) * 1000;
    let index = 0;

    this._autoplayInterval = window.setInterval(() => {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      if (this.matches(':hover')) return;
      const cards = Array.from(this.querySelectorAll('[data-notxs-feed-card]'));
      if (cards.length < 2) return;
      index = (index + 1) % cards.length;
      this.viewport.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
    }, speed);
  }
}

function bindNotxsProductForm(form) {
  if (form.dataset.notxsBound === 'true') return;
  form.dataset.notxsBound = 'true';

  const select = form.querySelector('[data-notxs-variant-select]');
  const price = form.querySelector('[data-notxs-price]');
  const message = form.querySelector('[data-notxs-form-message]');

  if (select && price) {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (option?.dataset.price) price.textContent = option.dataset.price;
    });
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const action = form.dataset.actionMode || 'cart';
    const variantField = form.querySelector('[data-notxs-variant-id]');
    const variantId = variantField?.value;
    const submit = form.querySelector('[data-notxs-submit]');

    if (action === 'product') {
      window.location.href = form.dataset.productUrl || '/';
      return;
    }

    if (!variantId) {
      if (message) message.textContent = 'Selecione uma opção.';
      return;
    }

    if (submit) submit.disabled = true;
    if (message) message.textContent = '';

    const settings = window.MinimogSettings || {};
    const addUrl = (settings.routes && settings.routes.cart_add_url) || '/cart/add.js';
    const cartDrawer = document.querySelector('m-cart-drawer');
    const useDrawer = Boolean(cartDrawer && settings.enable_cart_drawer);

    const body = { id: Number(variantId), quantity: 1 };
    if (useDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map((section) => section.id).join(',');
      body.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      });

      const addedItem = await response.json().catch(() => ({}));

      if (addedItem.status || !response.ok) {
        throw new Error(addedItem.description || addedItem.message || 'cart_error');
      }

      if (action === 'checkout') {
        window.location.href = '/checkout';
        return;
      }

      if (message) message.textContent = 'Produto adicionado ao carrinho.';
      if (typeof window.notxsOpenCartDrawer === 'function') {
        window.notxsOpenCartDrawer(cartDrawer, addedItem);
      } else if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
        cartDrawer.onCartDrawerUpdate();
        cartDrawer.open();
      }
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, addedItem);
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: addedItem } }));
      document.dispatchEvent(new CustomEvent('notxs:cart-added'));
    } catch (error) {
      if (message) message.textContent = 'Não foi possível adicionar agora.';
    } finally {
      if (submit) submit.disabled = false;
    }
  });
}

if (!customElements.get('notxs-social-feed')) {
  customElements.define('notxs-social-feed', NotxsSocialFeed);
}

window.bindNotxsProductForm = bindNotxsProductForm;
